const o = `<svg viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg">
    <path
        d="M9.938,9.26,8.083,5.876A3.748,3.748,0,1,0,1.25,3.75a3.72,3.72,0,0,0,.667,2.126L.062,9.26A.5.5,0,0,0,.5,10a.44.44,0,0,0,.089-.008l2.75-.5A.5.5,0,0,0,3.72,9.17l.628-1.736A3.686,3.686,0,0,0,5,7.5a3.686,3.686,0,0,0,.652-.066L6.28,9.17a.5.5,0,0,0,.381.322l2.75.5A.44.44,0,0,0,9.5,10a.5.5,0,0,0,.438-.74ZM5,6A2.25,2.25,0,1,1,7.25,3.75,2.252,2.252,0,0,1,5,6Z"
        fill="currentColor" stroke="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="0"></path>
</svg>`;
export {
  o as default
};
